import { FormItem, FormRow } from '@/pages/ProjectCreatePage/components/StepOne/StepOne'
import styles from './ApplyTrialBoxMobile.module.less'
import { observer } from 'mobx-react-lite'
import cls from 'classnames'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import TRANSLATION from '@/i18n/locales/zh/translation'
import DefaultAvatar from '@/components/DefaultAvatar/DefaultAvatar'
import AInput from '@/components/A/AInput/AInput'
import DropdownSelector from '@/components/ApplyTrialBox/components/DropdownSelector/DropdownSelector'
import AButton from '@/components/A/AButton/AButton'
import AIcon from '@/components/A/AIcon/AIcon'
import useTrialOptions from '@/helpers/commonHooks/useTrialOptions'
import MiddleText from '@/components/MiddleText/MiddleText'

export interface ApplyTrialParam {
  staffName: string,
  staffTel: string
  // 部门
  staffDepartment: string
  //职位
  staffPosition: string
  // 企业名称
  corpName: string,
  country: string
  city: string

}

interface Props {
  userInfo: Models.UserInfo
  onSubmit: (param: ApplyTrialParam) => void
  className?: string
}

interface Opt {
  label: string
  value: string
}


function ApplyTrialBoxMobile(props: Props) {
  const { t } = useTranslation()
  const {
    // CountryEnum,
    DEPARTMENT_OPTIONS,
    // COUNTRY_OPTIONS,
    ROLE_OPTIONS
  } = useTrialOptions()


  const [name, setName] = useState<string | undefined>(undefined)
  const [tel, setTel] = useState<string | undefined>(undefined)
  const [department, setDepartment] = useState<Opt | undefined>(undefined)
  const [role, setRole] = useState<Opt | undefined>(undefined)
  // const [country, setCountry] = useState<Opt | undefined>(undefined)
  // const [city, setCity] = useState<string | undefined>(undefined)
  const [formError, setFromError] = useState([
    { key: 'name', error: false, msg: '' },
    { key: 'tel', error: false, msg: '' },
    { key: 'department', error: false, msg: '' },
    { key: 'role', error: false, msg: '' },
    { key: 'country', error: false, msg: '' },
    { key: 'city', error: false, msg: '' },
  ])

  const validate = (force: boolean = false) => {
    const validateError = formError
    const nameError = (force: boolean) => {
      const error = force ? !name : name === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const telError = (force: boolean) => {
      const error = force ? !tel : tel === ''
      // 校验手机号格式，支持中国和国外手机号
      // 中国手机号：11位数字，国外手机号：允许数字、+、-、空格，长度4-20
      if (!error && tel) {
        // 国外手机号校验
        if (!/^[\d+\-\s]{4,20}$/.test(tel)) {
          return { error: true, msg: t('modals.freeTrialModal.applyBox.pleaseEnterValidTel') }
        }
      }
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const departmentError = (force: boolean) => {
      const error = force ? (!department || department?.label === '') : department?.label === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    const roleError = (force: boolean) => {
      const error = force ? (!role || role?.label === '') : role?.label === ''
      return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    }
    // const countryError = (force: boolean) => {
    //   const error = force ? (!country || country?.label === '') : country?.label === ''
    //   return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    // }
    // const cityError = (force: boolean) => {
    //   const error = force ? (!city || city === '') : city === ''
    //   return { error, msg: error ? t('modals.freeTrialModal.applyBox.textIsRequired') : '' }
    // }

    const index1 = validateError.findIndex(e => e.key === 'name')
    validateError[index1].error = nameError(force).error
    validateError[index1].msg = nameError(force).msg
    const index2 = validateError.findIndex(e => e.key === 'tel')
    validateError[index2].error = telError(force).error
    validateError[index2].msg = telError(force).msg
    const index3 = validateError.findIndex(e => e.key === 'department')
    validateError[index3].error = departmentError(force).error
    validateError[index3].msg = departmentError(force).msg
    const index4 = validateError.findIndex(e => e.key === 'role')
    validateError[index4].error = roleError(force).error
    validateError[index4].msg = roleError(force).msg
    // const index5 = validateError.findIndex(e => e.key === 'country')
    // validateError[index5].error = countryError(force).error
    // validateError[index5].msg = countryError(force).msg
    // const index6 = validateError.findIndex(e => e.key === 'city')
    // validateError[index6].error = country?.value === CountryEnum.China ? cityError(force).error : false
    // validateError[index6].msg = country?.value === CountryEnum.China ? cityError(force).msg : ''
    return [...validateError]
  }

  const handleSubmit = () => {
    const validateError = validate(true)
    setFromError(validateError)
    const allPass = validateError.every(e => !e.error)
    if (allPass) {
      props.onSubmit({
        staffName: name || '',
        staffTel: tel || '',
        staffDepartment: (TRANSLATION as any).modals.freeTrialModal.department[department?.value || ''],
        staffPosition: (TRANSLATION as any).modals.freeTrialModal.role[role?.value || ''],
        corpName: props.userInfo.corpName || '',
        /** 因为后端要中文，但是前端 label 是多语言，因此通过中文语言文件转译一下 */
        // country: (TRANSLATION as any).modals.freeTrialModal.country[country?.value || ''],
        // city: city || '',
        country: '',
        city: '',
      })
    }
  }


  useEffect(() => {
    const validateError = validate()
    setFromError(validateError)
  }, [name, tel, department, role,
    // country, city,
  ])

  return <div className={cls(styles.applyTrialBox, props.className)}>
    <div className={styles.trialAccountBox}>
      <div className={styles.trialAccount}>
        <DefaultAvatar name={props.userInfo.name} avatar={props.userInfo.avatar} />
        <div className={styles.accountDesc}>
          <div className={styles.accountName}>
            <span className={styles.name}>
              <MiddleText text={props.userInfo.name}></MiddleText>
            </span>
            <span className={styles.corpName}>
              <span className={styles.corpNameText}>{props.userInfo.corpName}1111</span>
            </span>
          </div>
          <p className={styles.accountEmail}>{props.userInfo.email}</p>
        </div>
      </div>
    </div>
    <div className={styles.formBox}>
      <FormRow>
        <FormItem required
          label={t('modals.freeTrialModal.applyBox.name')}
          labelRender={(label) => <div className={styles.formItemLabel}>{label}</div>}
          error={formError.find(e => e.key === 'name')?.error}
          errorMsg={formError.find(e => e.key === 'name')?.msg}>
          <AInput
            testId='free-trial-mobile-name-input'
            className={styles.inputWidth}
            placeholder={t('modals.freeTrialModal.applyBox.pleaseEnterTheName')} value={name} onChange={e => {
              setName(e.target.value)
            }}
            onBlur={() => {
              window.scrollTo(0, 0)
            }}
          />
        </FormItem>
      </FormRow>
      <FormRow>
        <FormItem required
          label={t('modals.freeTrialModal.applyBox.tel')}
          labelRender={(label) => <div className={styles.formItemLabel}>{label}</div>}
          error={formError.find(e => e.key === 'tel')?.error}
          errorMsg={formError.find(e => e.key === 'tel')?.msg}>
          <AInput
            testId='free-trial-mobile-tel-input'
            className={styles.inputWidth}
            placeholder={t('modals.freeTrialModal.applyBox.pleaseEnterTheTel')} value={tel} onChange={e => {
              setTel(e.target.value)
            }}
            onBlur={() => {
              window.scrollTo(0, 0)
            }}
          />
        </FormItem>
      </FormRow>
      <FormRow>
        <FormItem required
          label={t('modals.freeTrialModal.applyBox.department')}
          labelRender={(label) => <div className={styles.formItemLabel}>{label}</div>}
          error={formError.find(e => e.key === 'department')?.error}
          errorMsg={formError.find(e => e.key === 'department')?.msg}>
          <DropdownSelector testId='free-trial-mobile-department-selector' className={styles.mobileDropdown} menuClassName={styles.mobileDropdownMenu} options={DEPARTMENT_OPTIONS}
            otherPlaceholder={t('modals.freeTrialModal.applyBox.pleaseEnter')}
            placeholder={t('modals.freeTrialModal.applyBox.pleaseSelectTheDepartment')}
            onChange={opt => {
              setDepartment(opt)
            }}
            onBlur={() => {
              window.scrollTo(0, 0)
            }}
          />
        </FormItem>
      </FormRow>
      <FormRow>
        <FormItem required
          label={t('modals.freeTrialModal.applyBox.role')}
          labelRender={(label) => <div className={styles.formItemLabel}>{label}</div>}
          error={formError.find(e => e.key === 'role')?.error}
          errorMsg={formError.find(e => e.key === 'role')?.msg}>
          <DropdownSelector testId='free-trial-mobile-role-selector' className={styles.mobileDropdown} menuClassName={styles.mobileDropdownMenu} options={ROLE_OPTIONS}
            otherPlaceholder={t('modals.freeTrialModal.applyBox.pleaseEnter')}
            placeholder={t('modals.freeTrialModal.applyBox.pleaseSelectTheRole')}
            onChange={opt => {
              setRole(opt)
            }}
            onBlur={() => {
              window.scrollTo(0, 0)
            }}
          />
        </FormItem>
      </FormRow>
      {/* <FormRow>
        <FormItem required
          label={t('modals.freeTrialModal.applyBox.country')}
          labelRender={(label) => <div className={styles.formItemLabel}>{label}</div>}
          error={formError.find(e => e.key === 'country')?.error}
          errorMsg={formError.find(e => e.key === 'country')?.msg}>
          <div>
            <DropdownSelector className={styles.mobileDropdown} menuClassName={styles.mobileDropdownMenu} options={COUNTRY_OPTIONS}
              otherPlaceholder={t('modals.freeTrialModal.applyBox.pleaseEnter')}
              placeholder={t('modals.freeTrialModal.applyBox.pleaseSelectTheCountry')}
              onChange={opt => {
                setCountry(opt)
              }}
              onBlur={() => {
                window.scrollTo(0, 0)
              }}
            />
          </div>
        </FormItem>
      </FormRow> */}
      {/* {
        country?.value === CountryEnum.China &&
        <FormRow>
          <FormItem required
            label={t('modals.freeTrialModal.applyBox.city')}
            labelRender={(label) => <div className={styles.formItemLabel}>{label}</div>}
            error={formError.find(e => e.key === 'city')?.error}
            errorMsg={formError.find(e => e.key === 'city')?.msg}>
            <AInput
              className={styles.inputWidth}
              placeholder={t('modals.freeTrialModal.applyBox.pleaseEnterTheCity')} value={city}
              onChange={e => {
                setCity(e.target.value)
              }}
              onBlur={() => {
                window.scrollTo(0, 0)
              }}
            />
          </FormItem>
        </FormRow>
      } */}
    </div>
    <div className={styles.btnBox}>
      <AButton testId='free-trial-mobile-submit-btn' type='primary' size='LG' onClick={handleSubmit}>
        <span>{t('modals.freeTrialModal.applyBox.submit')}</span>
        <AIcon className={styles.arrowIcon} type='icon-line-global_arrow'></AIcon>
      </AButton>
    </div>
    <p className={styles.tip}>{t('modals.freeTrialModal.applyBox.tip')}</p>
  </div>
}

export default observer(ApplyTrialBoxMobile)
